import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogRef } from '../../../dialog/dialog-ref';
import { DialogConfig } from '../../../dialog/dialog-config';
import confirmDialogLocalization from './confirm-dialog.localization';

@Component({
  selector: 'mtg-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  message: string = this.dialogConfig.data.message;
  localization = confirmDialogLocalization;

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig,
  ) {}

  close(value: boolean) {
    this.dialogRef.close(value);
  }
}
